import React from 'react';
import {
    FontAwesomeIcon,
} from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const InnerSpinner = styled.div`
    font-size: 1.5rem;
    font-weight: regular;
    color: #c3c3c3;
    display: flex;
    align-items: center;
    height: 2.25rem;
    justify-content: center;
    animation: ${rotate} 1s ease infinite;
`;

const Spinner = ():React.ReactElement => (
    <InnerSpinner>
        <FontAwesomeIcon icon={faSpinner} />
    </InnerSpinner>
);

export default Spinner;
